<template>
    <div class="HorizontalSlider">
        <swiper :options="swiperOption" ref="mySwiper" class="HorizontalSlider-container">
            <!-- slides -->
            <swiper-slide v-for="(item, index) in items" :key="index">
                <slot name="item" :item="item" :class="'slide-slot'" ></slot>
            </swiper-slide>
            <!-- Optional controls -->
            <div v-if="show_pagination" class="swiper-pagination"  slot="pagination"></div>
        </swiper>
    </div>
</template>

<script>
    /*
    * Uses vue-awesome-swiper
    * For Docs look at the examples on: https://surmon-china.github.io/vue-awesome-swiper/
    * click on the '< >' button to see the code for each ^
    */
    import { swiper, swiperSlide } from 'vue-awesome-swiper'

    export default {
        name: 'horizontal-slider',
        props: {
            show_arrows: {
                default: false,
            },
            show_pagination: {
                default: true,
            },
            show_scrollbar: {
                default: false,
            },
            infinite: {
                default: true,
            },
            speed: {
                default: 1000,
            },
            timeout: {
                default: 2000,
            },
            items : {
                default: () => [],
                type: Array,
            },
        },
        data() {
            return {
                swiperOption: {
                    pagination: {
                      el: '.swiper-pagination',
                      clickable: true
                    },
                    autoplay: {
                        disableOnInteraction: true
                    },
                    loop: true
                }
            }
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.swiper
            }
        },
        components: {
            swiper,
            swiperSlide
        },
        mounted(){
        },
    }
</script>

<style lang="scss">

    @import '_vue';

    
    .HorizontalSlider {
        width: 100%;
        height: 100%;
        
        img {
            width: 100%;
        }
        
        .HorizontalSlider-container {
            height: 100%;
            z-index: 0;

            .swiper-wrapper {
                z-index: 0;
            }
            
        }

        .slider-image {
            height: 100%;
            background: {
                size: cover;
                repeat: no-repeat;
                position: center center;
            }
        }
        
    }


    

    .swiper-slide {
        text-align: center;
        img {
            width:100%;
        }
    }

</style>


// WEBPACK FOOTER //
// assets/js/vue/components/HorizontalSlider.vue